/**
 * A wrapper around $window.location.reload() for easier testing
 */
export function reload() {
  console.log('*'.repeat(50) + '_'.repeat(35) + '*'.repeat(50));
  window.location.reload();
}
